import React, { useState } from "react"
import './ballusion.css';
import SEO from "../components/seo";

function getRandomElement(list) {
    return list[Math.floor(Math.random() * list.length)]
}

function getBalloun(list) {
    const b = getRandomElement(list.nodes)
    return b.publicURL;
}

function step3ExplodeAction(state, setState, terms) {
    setState({
        ...state,
        step3ExplodeState: "Ballusion__BallounSlot_Run"
    })
    setTimeout(() => {
        const selectedTerms = []
        let i = 1000;
        while (selectedTerms.length < 5 && i > 0) {
            const t = getRandomElement(terms);
            if (selectedTerms.indexOf(t) < 0) {
                selectedTerms.push(t)
            }
            i--;
        }
        setState({
            ...state,
            step: 4,
            terms: selectedTerms,
            step3ExplodeState: null
        })
    }, 500)
}

function createTermPosition(i,c){
    const distX = Math.random()*300 +50;
    const distY = Math.random()*100 +50;
    const angle = i * (Math.PI*2/c) + Math.PI/12 * (Math.random()-0.5)
    const x = Math.cos(angle) * distX;
    const y = Math.sin(angle) * distY;
    return {
        transform: `translate(calc(${x}px - 50%),calc(${y}px - 50%)) rotate(${Math.random() > 0.5 ? '-' : ''}${Math.random() * 25}deg)`
    }
}

function renderStep(index, state, setState, data) {
    const { ballounsDesc, ballounsFiles, iconRefresh, iconCheck, iconExploded, exploded, terms } = data;

    switch (index) {
        default:
        case 0:
            return (
                <div className="Ballusion__Content">
                    <img className="Ballusion__IntroImg" src={ballounsDesc.publicURL} alt="Ballouns" />
                    <button type="button" className="Ballusion__IntroButton button" onClick={() => setState({
                        ...state,
                        step: 1,
                        balloun: getBalloun(ballounsFiles)
                    })} >LAUNCH BALLUSION</button>
                </div>
            )
        case 1:
            return (
                <div className="Ballusion__Content">
                    <div className="Ballusion__BallounSlot">
                        <img className="Ballusion__BallounSlotBall" src={state.balloun} alt="Ballouns" />
                    </div>
                    <div className="Ballusion__Desc">
                        Select a balloon you like!
                    </div>
                    <div className="Ballusion__Buttons">
                        <button type="button" className="Ballusion__ValidButton button" onClick={() => setState({
                            ...state,
                            step: 2
                        })} ><img className="icon" alt="Check icon" src={iconCheck.publicURL} /> SELECT THIS BALLOON</button>
                        <button type="button" className="Ballusion__GenerateoButton button" onClick={() => setState({
                            ...state,
                            balloun: getBalloun(ballounsFiles)
                        })} ><img className="icon" alt="Refresh icon" src={iconRefresh.publicURL} /> GENERATE A NEW BALLOON</button>
                    </div>
                </div>
            )
        case 2:
            return (
                <div className="Ballusion__Content">
                    <div className="Ballusion__BallounSlot">
                        <img className="Ballusion__BallounSlotBall" src={state.balloun} alt="Ballouns" />
                    </div>
                    <div className="Ballusion__Desc">
                        Reflect on the shape of your balloon:
                        <span>How does it relate to futures? To your design project or practice?</span>
                    </div>
                    <div className="Ballusion__Buttons">
                        <button type="button" className="Ballusion__ValidButton button" onClick={() => setState({
                            ...state,
                            step: 3
                        })} ><img className="icon" alt="Check icon" src={iconCheck.publicURL} /> I’M DONE REFLECTING, NEXT STEP!</button>
                    </div>
                </div>
            )
        case 3:
            return (
                <div className={"Ballusion__Content" + (state.step3ExplodeState ? " " + state.step3ExplodeState : "")}>
                    <div className="Ballusion__BallounSlot Ballusion__BallounSlotStep3">
                        <img className="Ballusion__BallounSlotBall" src={state.balloun} alt="Ballouns" />
                        <img className="Ballusion__BallounSlotExploded" src={exploded.publicURL} alt="Ballouns" />
                    </div>
                    <div className="Ballusion__Desc">
                        Be ready to pop your balloon!
                        <span>Which future terms does your balloon hold?</span>
                    </div>
                    <div className="Ballusion__Buttons">
                        <button type="button" className="Ballusion__ValidButton button" onClick={() => step3ExplodeAction(state, setState, terms.terms)} ><img className="icon" alt="Check icon" src={iconExploded.publicURL} /> LET’S POP THE BALLOON!</button>
                    </div>
                </div>
            )
        case 4:
            return (
                <div className="Ballusion__Content">
                    <div className="Ballusion__Terms">
                        <div className="Ballusion__TermsCenter">
                        {state.terms.map((o,i) => <div key={o} className="Ballusion__Term"
                            style={createTermPosition(i,state.terms.length)}
                        >{o}</div>)}
                        </div>
                    </div>
                    <div className="Ballusion__Desc">
                        Here are the terms from your balloon!
                        <span>How do these terms connect with your project, course or discipline?</span>
                    </div>
                    <div className="Ballusion__Buttons">
                        <button type="button" className="Ballusion__ValidButton button" onClick={() => setState({
                            step: 1,
                            balloun: getBalloun(ballounsFiles),
                            step3ExplodeState: null,
                            terms: []
                        })} ><img className="icon" alt="Refresh icon" src={iconRefresh.publicURL} /> GENERATE A NEW BALLOON</button>
                    </div>
                </div>
            )
    }
}

const BallusionIndexPage = ({ data }) => {
    const { logo } = data;

    const [state, setState] = useState({
        step: 0,
        balloun: null,
        step3ExplodeState: null,
        terms: []
    });

    return (
        <div className="Wrapper BallusionWrapper">
            <SEO title="FUEL4DESIGN: Lexicon Ballusion" description="BALLUSION helps you to think about design futures in terms of language and metaphors." />
            <div className="Ballusion">
                <header
                    className="Ballusion__Header"
                >
                    <img className="Ballusion__Logo" src={logo.publicURL} alt="FUEL4Design" />
                    <div className="Ballusion__Title">(ONLINE) <strong>BALLUSION:</strong></div>
                </header>
                <main className="Ballusion__Main">
                    {state.step > 0 && <div className="Ballusion__Step">STEP {state.step}/4</div>}
                    {renderStep(state.step, state, setState, data)}
                </main>
                <footer className="Ballusion__Footer">
                    <div>Future Education and Literacy for Designers (ERASMUS +)</div>
                    <a target="_blank" rel="noopener noreferrer" href="http://fuel4design.org/index.php/design-futures-lexicon">Go to the Design Futures Lexicon</a>
                </footer>
            </div>
        </div>
    )
}

export default BallusionIndexPage

export const pageQuery = graphql`
  query BallusionIndexQuery {
    terms:termsYaml {
        terms
    }
    logo:file(base: {eq: "logo.svg"}) {
      base
      publicURL
    }
    ballounsDesc:file(base: {eq: "ballouns.svg"}) {
        base
        publicURL
    }
    ballounsFiles:allFile(filter: {sourceInstanceName: {eq: "ballouns"}}) {
        nodes {
          base
          publicURL
        }
      }
    iconRefresh:file(base: {eq: "icon-refresh.svg"}) {
      base
      publicURL
    }
    iconCheck:file(base: {eq: "icon-check.svg"}) {
        base
        publicURL
      }
    iconBallouns:file(base: {eq: "icon-ballouns.svg"}) {
        base
        publicURL
    }
    iconExploded:file(base: {eq: "icon-exploded.svg"}) {
        base
        publicURL
    }
    exploded:file(base: {eq: "exploded.svg"}) {
        base
        publicURL
    }
  }
`;

